import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_ROOT,
    withCredentials: true,
});

// Also attach Authorization header if we saved a token in localStorage as a fallback
// (some browsers strip 3rd party cookies aggressively).
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("srtf_access_token");
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Convert relative backend paths ("/api/files/...") to absolute preview URLs
export function absUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/")) return `${BACKEND_URL}${path}`;
    return path;
}
